import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import './signUpPopup.css';

const SignUpPopup = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [initialScroll, setInitialScroll] = useState(0);
  const navigate = useNavigate();

  const getScrollTriggerThreshold = () => {
    const width = window.innerWidth;

    if (width <= 480) return 600;     // Mobile
    if (width <= 768) return 750;     // Tablet
    return 900;                       // Desktop
  };

  useEffect(() => {
    const triggerHeight = getScrollTriggerThreshold();

    const handleScroll = () => {
      if (window.scrollY > triggerHeight && !popupVisible) {
        setPopupVisible(true);
        setInitialScroll(window.scrollY);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [popupVisible]);

  useEffect(() => {
    if (popupVisible) {
      const preventScroll = (e) => {
        if (window.scrollY > initialScroll) {
          window.scrollTo(0, initialScroll);
        }
      };

      window.addEventListener('scroll', preventScroll);

      return () => {
        window.removeEventListener('scroll', preventScroll);
      };
    }
  }, [popupVisible, initialScroll]);

  const signUp = () => {
    navigate("/register");
  };

  return (
    <>
      {popupVisible && (
        <>
          <div className="popup-overlay-SignUpPopUp"></div>
          <div className="popup-SignUpPopUp">
            <div className="popup-content-SignUpPopUp">
              <div className='border-content-SignUpPopUp'>
                <p style={{fontSize:"36px", fontWeight:"400"}}>Continue reading this article for free!</p>
                <p style={{fontSize:"24px", fontWeight:"400"}}>Sign up to get access to 3 free articles!</p>
                <button onClick={signUp}>Sign Me Up!</button>
                <p>Already have an account? <Link to="/login">Sign In</Link></p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SignUpPopup;
